<template>
  
  <div>
    <form id="stripe-payment-element-form" class="d-flex flex-column ">
      <!-- Billing address (Stripe Tax): Stripe's Address Element, same Elements group as the card,
           so it's attached to the card and gets address autocomplete. Saved before the card. -->
      <div class="d-flex flex-column w-100">
        <label class="fs-stripe fw-bold mb-2">Billing Address <span class="error">*</span></label>
        <div id="stripe-address-element-mount-point" />
        <div v-if="zipConfirmMessage" class="mt-3">
          <span class="fs-6" style="color: #b45309">{{ zipConfirmMessage }}</span>
          <button type="button" class="btn btn-outline-secondary btn-sm ml-2" @click="useAddressAnyway">Use this address</button>
        </div>
        <span v-if="billingError" class="fs-6 mt-2" style="color: red">{{ billingError }}</span>
      </div>
      <!-- Annual plan: where the Crimes Listing Booklet ships (kept locally, never sent to Stripe). -->
      <div v-if="price != 39.95" class="d-flex justify-content-center align-items-center w-100 mt-4">
        <div class="flex-column d-flex w-100">
          <div class="d-flex align-items-center mb-2">
            <input id="shippingSameAsBilling" type="checkbox" class="mr-2" v-model="shippingSameAsBilling" />
            <label class="fs-6 mb-0" for="shippingSameAsBilling">Ship my Crimes Listing Booklet to my billing address</label>
          </div>
          <template v-if="!shippingSameAsBilling">
          <i class="fs-5 py-3">This is the address where your new Crimes Listing Booklet will be sent to.</i>
          <div class="d-flex w-100">
            <div class="d-flex flex-column col-6 p-0">
              <label class="fs-stripe">Shipping Address <span class="error">*</span></label>
              <input class="stripeLike mb-4" type="text" v-model="address" />
              <small v-if="formIncomplete && !address?.length" style="color: red">*Address is required</small>
            </div>
            <div class="d-flex flex-column col-6">
              <label class="fs-stripe">City <span class="error">*</span></label>
              <input class="stripeLike mb-4" type="text" v-model="city" />
              <small v-if="formIncomplete && !city?.length" style="color: red">*City is required</small>
            </div>
          </div>
          <div class="d-flex w-100 justify-content-between">
            <div class="d-flex flex-column col-6 p-0">
              <label class="fs-stripe">Address 2</label>
              <input class="stripeLike" type="text" v-model="address2" />
            </div>
            <div class="d-flex flex-column col-3">
              <label class="fs-stripe">State <span class="error">*</span></label>
              <input class="stripeLike" type="text" v-model="state" />
              <small v-if="formIncomplete && !state?.length" style="color: red">*State is required</small>
            </div>
            <div class="d-flex flex-column col-3 p-0">
              <label class="fs-stripe">Zip Code <span class="error">*</span></label>
              <input class="stripeLike" type="text" v-model="zipCode" />
              <small v-if="formIncomplete && !zipCode?.length" style="color: red">*Zip Code is required</small>
            </div>
          </div>
          </template>
        </div>
      </div>
      <div id="stripe-payment-element-mount-point" class="py-5 " />
      <slot name="stripe-payment-element-errors"></slot>
      <div class="d-flex w-100 my-3">
        <p class=" fs-3" style="font-weight: 400">
          <span class="fs-2 fw-bold">${{ price.toFixed(2) }} / {{ price === 39.95 ? "monthly" : "year" }}</span>
        </p>
      </div>
      <div class="d-flex flex-column w-100">
        <p class="fs-6 " style="font-weight: 400">
          By submitting, you agree to be charged the above amount plus applicable sales tax, renewed {{ price == "39.95" ? "monthly" : "annually" }}.
          <br />
          You can cancel your subscription at any time.
        </p>
        <!-- <div class="d-flex  mt-3">
          <input type="checkbox" id="readTerms" v-model="readTerms" />
          <label class="mb-0 m-0 ml-2 " for="readTerms">
            I have read and agree to the
            <a href="https://placergroup.com/legalpolicies/termsofservice" class="link" target="_blank">Terms of Service</a>
          </label>
        </div> -->
        <span class="fs-5" v-if="errorProp" style="color: red">**{{ errorProp }}**</span>
        <span v-if="cardDeclined" style="color: red" class="fs-5">Your card was declined. Please try a different payment method.</span>
        <span v-if="validationError" style="color: red" class="fs-5">There was a validation error with your card. Please check your card details and try again.</span>
        <span v-if="unexpectedError" style="color: red" class="fs-5">Please try a different payment method or retry. An unexpected error occurred.</span>
        <div class="d-flex justify-content-center w-100">
          <div>
            <loading-button v-if="loading" ></loading-button>
          <button
            v-if="!loading"
            ref="submitButtonRef"
            type="submit"
            class="btn btn-primary btn-xl my-2 text-align-center mt-4"
          >
            Start Trial
          </button>
          </div>
          
        </div>
        
      </div>
    </form>
  </div>
</template>

<script>
import LoadingButton from "../../components/utils/LoadingButton.vue";
import { loadStripe } from "@stripe/stripe-js/dist/pure.esm.js";
import axios from "axios";
import { addressElementOptions, toBillingPayload, shippingFromBilling, describeSaveError } from "../../billingAddressForm.js";

export default {
  components: { LoadingButton },
  props: {
    elementsOptions: {
      type: Object,
      required: true,
      default: () => ({}),
    },
    confirmParams: {
      type: Object,
      required: true,
      default: () => ({ return_url: process.env.VUE_APP_URL + "/subscriptionConfirm" }),
    },
    redirect: {
      type: String,
      default: "always",
    },
    price: {
      type: Number,
      required: true,
    },
    setupIntent: {
      type: Object,
      required: true,
    },
    errorProp: {
      type: String,
      required: false,
    },
  },
  data() {
    return {
      loading: false,
      stripe: null,
      elements: null,
      element: null,
      city: null,
      phone: null,
      state: null,
      zipCode: null,
      address: null,
      address2: null,
      error: null,
      // readTerms: false,
      formIncomplete: false,
      // Billing address (Stripe Tax)
      addressElement: null,
      shippingSameAsBilling: true,
      billingError: null,
      zipConfirmMessage: null,
      confirmZipState: false,
      isUnmounted: false,
      localErrorProp: this.errorProp, // local property to track error state

      //error handling
      cardDeclined: false,
      validationError: false,
      unexpectedError: false,
    };
  },
  async mounted() {
    // Handle submit right away (before Stripe loads) so an early click can't do a native form submit.
    const form = document.getElementById("stripe-payment-element-form");
    form.addEventListener("submit", this.handleSubmit);

    // Load Stripe and the saved billing address (for prefill) at the same time.
    const user = JSON.parse(localStorage.getItem("user_attr") || "null");
    let stripe;
    let savedAddress;
    try {
    [stripe, savedAddress] = await Promise.all([
      loadStripe(process.env.VUE_APP_STRIPE_PUBLISHABLE_KEY, {}),
      axios
        .get(process.env.VUE_APP_ENDPOINT + "/api/stripesubscription/billingAddress", {
          headers: { Authorization: `Bearer ` + localStorage.getItem("user_token") },
        })
        .then((r) => r?.data?.billingAddress || null)
        .catch(() => null),
    ]);
    } catch (e) {
      if (this.isUnmounted) return;
      // Stripe.js blocked (ad blocker / network): say so instead of a form that silently does nothing.
      console.error(e);
      this.billingError = "We couldn't load the secure payment form. Please refresh the page (and allow js.stripe.com if an ad blocker is on).";
      return;
    }
    // Left the page (e.g. Back / another plan) while loading: don't mount into the new instance's DOM.
    if (this.isUnmounted) return;
    this.stripe = stripe;
    this.elements = this.stripe.elements({
      clientSecret: this.setupIntent.client_secret,
    });
    // Billing address (same Elements group as the card), prefilled with what's saved.
    this.addressElement = this.elements.create(
      "address",
      addressElementOptions({ name: [user?.FirstName, user?.LastName].filter(Boolean).join(" "), savedAddress })
    );
    this.addressElement.mount("#stripe-address-element-mount-point");
    this.addressElement.on("change", () => {
      // An edited address needs a fresh ZIP/state check.
      this.zipConfirmMessage = null;
      this.confirmZipState = false;
      this.billingError = null;
    });

    this.element = this.elements.create("payment");
    this.element.mount("#stripe-payment-element-mount-point");
    this.element.on("change", this.handleStripeElementChange);
  },
  beforeUnmount() {
    this.isUnmounted = true;
  },
  methods: {
    // "Use this address" after the ZIP/state warning: save it as entered.
    useAddressAnyway() {
      this.confirmZipState = true;
      this.zipConfirmMessage = null;
      this.handleSubmit({ preventDefault() {} });
    },
    // Saves the billing address (validated by the server and Stripe Tax). Returns the address, or
    // null after showing what's wrong.
    async saveBillingAddress() {
      const { complete, value } = await this.addressElement.getValue(); // shows field errors
      if (!complete) return null;
      const billing = toBillingPayload(value);
      try {
        const response = await axios.post(
          process.env.VUE_APP_ENDPOINT + "/api/stripesubscription/billingAddress",
          { address: billing, confirmZipState: this.confirmZipState },
          { headers: { Authorization: `Bearer ` + localStorage.getItem("user_token") } }
        );
        // Use what the server saved (trimmed, state upper-cased) for the shipping copy too.
        return response?.data?.billingAddress || billing;
      } catch (e) {
        const problem = describeSaveError(e?.response, billing);
        if (problem.needsZipConfirmation) this.zipConfirmMessage = problem.message;
        else this.billingError = problem.message;
        return null;
      }
    },
    handleStripeElementChange(event) {
      if (event.error) {
        this.localErrorProp = event.error.message;
      } else {
        this.localErrorProp = null;
      }
    },
    async handleSubmit(event) {
      event.preventDefault();
      if (!this.elements || !this.addressElement || this.loading) return; // Stripe still loading / already submitting

      // Clear previous errors
      this.localErrorProp = null;
      this.cardDeclined = false;
      this.validationError = false;
      this.unexpectedError = false;

      this.billingError = null;
      this.zipConfirmMessage = null;

      // Check if form is complete (shipping is only typed in when it differs from billing)
      if (this.price != 39.95 && !this.shippingSameAsBilling) {
        if (!this.address?.length || !this.city?.length || !this.state?.length || !this.zipCode?.length) {
          this.formIncomplete = true;
          return;
        }
      }

      this.formIncomplete = false;

      // Check for Stripe card errors
      const stripeErrorElement = document.getElementById("stripe-payment-element-errors");
      if (stripeErrorElement && stripeErrorElement.textContent) {
        this.localErrorProp = stripeErrorElement.textContent;
        return;
      }

      // Validate the card (and address) fields first, so nothing is saved for an incomplete form.
      this.loading = true;
      const submitted = await this.elements.submit().catch((e) => ({ error: e }));
      if (submitted?.error) {
        // Could be the address or the card: Stripe's message names the field.
        this.billingError = submitted.error.message || "Please complete the highlighted fields.";
        this.loading = false;
        return;
      }

      // Billing address next: if it can't be saved, stop before the card is confirmed (that redirects).
      const billing = await this.saveBillingAddress();
      if (!billing) {
        this.loading = false;
        return;
      }
      if (this.price != 39.95 && this.shippingSameAsBilling) {
        Object.assign(this, shippingFromBilling(billing));
      }

      this.$emit("loading", true);
      this.loading = true;

      const user = JSON.parse(localStorage.getItem("user_attr"));
      const subscriberObj = {
        City: this.city,
        Address: this.address,
        Address2: this.address2,
        State: this.state,
        Zip: this.zipCode,
        Phone: user?.PhoneNumber,
        Id: user?.SubscriberId,
        IsMonthly: this.price == 39.95,
      };

      // Update Subscriber
      const subscriberResponse = await axios.patch(
        process.env.VUE_APP_ENDPOINT + `/api/subscriber/${user?.SubscriberId}`,
        subscriberObj,
        {
          headers: {
            Authorization: `Bearer ` + localStorage.getItem("user_token"),
          },
        }
      ).catch(e => {
        // Keep `loading` on: the card is confirmed next, and re-showing the button here allowed a
        // second, concurrent confirm. (e.response is missing on a network error.)
        console.error(e);
        return e?.response?.status === 402;
      });

      // Stripe setup confirmation
      const { error: stripeError, setupIntent } = await this.stripe.confirmSetup({
        elements: this.elements,
        confirmParams: this.confirmParams,
      });

      if (stripeError || setupIntent.status !== 'succeeded') {
        // console.log("Stripe error:", stripeError || 'Setup failed');
        let errorMessage = stripeError ? stripeError.message : 'Payment failed. Please check your card details and try again.';

        const errorElement = document.getElementById("stripe-payment-element-errors");
        if (errorElement) {
          errorElement.textContent = errorMessage;
        }

        // Provide additional user feedback for specific Stripe error types
        if (stripeError) {
          switch (stripeError.type) {
            case 'card_error':
              this.cardDeclined = true;
              break;
            case 'validation_error':
              this.validationError = true;
              break;
            default:
              this.unexpectedError = true;
              break;

          }
        }

        this.loading = false;
        return stripeError;
      }

      // If Stripe setup was successful, proceed with additional actions
      if (setupIntent.status === 'succeeded') {
        // console.log("Setup successful:", setupIntent);

        // Send the confirmation email
        const sendConfirmationResponse = await axios.post(
          `${process.env.VUE_APP_ENDPOINT}/api/registration/sendSubscriptionConfirmation`,
          {},
          {
            headers: {
              Authorization: `Bearer ` + localStorage.getItem("user_token"),
            },
          }
        );

        // console.log("sendConfirmationResponse", sendConfirmationResponse);
      }

      this.loading = false;
    },
  },





};
</script>

<style scoped>
.stripeLike {
  background-color: white !important;
  opacity: 1 !important;
  height: 40px;
  border: 1px #c7c7c7 solid;
  border-radius: 5px;
  font-size: 0.93rem;
  padding-left: 10px;
  box-shadow: 0px 1px 1px rgba(0, 0, 0, 0.03), 0px 3px 6px rgba(0, 0, 0, 0.02);
  transition: background 0.15s ease, border 0.15s ease, box-shadow 0.15s ease, color 0.15s ease
}
.fs-stripe {
  font-size: 0.93rem;
}


a {
  color: #007bff;
  text-decoration: none;
}

.link {
  color: var(--button) !important;
}
</style>
